import React from "react";
import {
  NavLink,
  Switch,
  Route,
  BrowserRouter
} from "react-router-dom";
import { Helmet } from "react-helmet";


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


import caseMathem from '../images/casestudy-mathem.png';

import izettle1 from '../images/izettle1.png';
import readly from '../images/readly.png';
import izettle2 from '../images/izettle2.png';
import mtr1 from '../images/mtr1.png';
import mtr2 from '../images/mtr2.png';
import storesampler1 from '../images/storesampler1.png';
import storesampler2 from '../images/storesampler2.png';
import freebee1 from '../images/freebee1.png';
import freebee2 from '../images/freebee2.png';
import freebee3 from '../images/freebee3.png';
import malmo from '../images/malmo.png';
import mario from '../images/mario.png';
import bikbok from '../images/bikbok.png';
import airrow from '../images/airrow.png';
import thand1 from '../images/thand1.png';
import thand2 from '../images/thand2.png';


function Navigation() {


  return (
    <span>
    <Row>
      <Col xs={12} md={12}>
        <h1 className="header-section gallery">Gallery</h1>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={readly} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={izettle1} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={mtr1} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={izettle2} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={storesampler1} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={mtr2} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={storesampler2} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={freebee2} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={malmo} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={mario} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={freebee3} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={bikbok} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={airrow} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={thand1} alt="Gallery" width="100%" />
        </div>
      </Col>
      <Col xs={12} md={6} lg={6} xl={4}>
        <div className="Gallery">
          <img src={thand2} alt="Gallery" width="100%" />
        </div>
      </Col>
    </Row>


    </span>

  );
}

export default Navigation;
